<template>
  <div>
    <v-dialog v-model="showDialog" :width="900" :persistent="true">
      <template #activator="{ on }">
        <v-btn color="primary" v-on="on">{{ 'page.user.import' | trans }}</v-btn>
      </template>
      <v-card>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>{{ 'page.user.import' | trans }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark small @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6 pa-2>
                  <v-menu
                      v-model="showStartDateInput"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="startDate"
                          readonly
                          :label="trans('app.start_date')"
                          v-on="on"
                          :rules="rules.start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="startDate" @input="showStartDateInput = false"
                                   locale="pl-pl" first-day-of-week="1"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 pa-2>
                  <v-menu
                      v-model="showEndDateInput"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="endDate"
                          readonly
                          :label="trans('app.end_date')"
                          v-on="on"
                          :rules="rules.end_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="endDate" @input="showEndDateInput = false" locale="pl-pl" first-day-of-week="1"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <input
                      class="hidden"
                      type="file"
                      ref="users"
                      accept="text/csv"
                      @change="filesChange"
                  >
                  <v-btn color="primary" @click="filesButtonClick()">{{ 'app.chose_file' | trans }}</v-btn>
                  <v-label>{{ selectedFileLabel }}</v-label>
                  <v-messages class="ml-2" v-if="fileValidationErrors.length > 0"
                              :value="fileValidationErrors"
                              :color="`error`"></v-messages>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="close">
            {{ 'app.close' | trans }}
          </v-btn>
          <v-btn color="primary"
                 @click="importUsers"
                 :disabled="!valid || fileValidationErrors.length > 0 || loading"
                 :loading="loading">
            {{ 'app.import' | trans }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {trans} from "../../../app";
import moment from 'moment';

export default {
  data: () => ({
    loading: false,
    valid: false,
    fileValidationErrors: [],
    showDialog: false,
    showStartDateInput: false,
    showEndDateInput: false,
    startDate: null,
    endDate: null,
    selectedFileLabel: '',
  }),
  computed: {
    rules() {
      return {
        start_date: [
          v => !!v || trans('validation.required', {'attribute': trans('app.start_date')}),
          v => v && moment(v).isBefore(moment(this.endDate)) || trans('validation.before', {
            'attribute': trans('app.start_date'),
            'date': trans('app.end_date')
          })
        ],
        end_date: [
          v => !!v || trans('validation.required', {'attribute': trans('app.end_date')}),
          v => v && moment(v).isAfter(moment(this.startDate)) || trans('validation.after', {
            'attribute': trans('app.end_date'),
            'date': trans('app.start_date')
          })
        ],
      }
    },
  },
  methods: {
    resetForm() {
      setTimeout(() => {
        this.$refs.form.resetValidation();
        this.valid = true;
        this.fileValidationErrors = [];
        this.loading = false;
        this.startDate = null;
        this.endDate = null;
        this.selectedFileLabel = '';
        this.$refs.users.value = null;
      }, 100);
    },
    open() {
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
      this.resetForm();
    },
    async importUsers() {
      this.loading = true;

      if (!this.valid || this.fileValidationErrors.length > 0) {
        this.loading = false;
        return;
      }

      let formData = new FormData();

      formData.set('start_date', this.startDate);
      formData.set('end_date', this.endDate);
      formData.set('users', this.$refs.users.files[0]);

      axios.post('/administrator/users/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }

      }).then(() => {
        this.close();
        this.$emit('imported');
      }).catch((error) => {
        this.$toast.error('Nie udało się zaimportować danych');
        this.sentryCaptureException(error);
      }).finally(() => {
        this.loading = false;
      })
    },
    filesButtonClick() {
      this.$refs.users.click();
    },
    filesChange($event) {
      const files = $event.target.files;
      if (files.length > 0) {
        this.selectedFileLabel = files[0].name;
      } else {
        this.selectedFileLabel = '';
      }
      this.validateFile();
    },
    validateFile() {
      this.fileValidationErrors = [];
      const files = this.$refs.users.files;

      if (files.length !== 1 || [
          'text/comma-separated-values',
          'text/csv',
          'application/csv',
          'application/excel',
          'application/vnd.ms-excel',
          'application/vnd.msexcel',
          'text/anytext',
      ].includes(files[0].type) === false) {
        this.fileValidationErrors = [
          trans('validation.mimes', {
            'attribute': '',
            'values': 'csv'
          })
        ];
      }
    }
  },
  watch: {
    async startDate() {
      await this.$nextTick();
      this.$refs.form.validate();
    },
    async endDate() {
      await this.$nextTick();
      this.$refs.form.validate();
    }
  }
}
</script>
